import React from 'react'
import classNames from 'classnames'
import { Paper, Typography } from '@mui/material'
import {
  rgbColors, setColors, whiteCold, whiteWarm,
} from '@app/lib/Scenes/colorActionTypes'
import { ColorTypes } from '@app/lib/Scenes/colorActions'
import { ADJUST_DURATION_COLOR, SELECT_COLOR_ACTION_HUE_AFTER_DURATION } from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import CardBlock from '@app/components/Common/CardBlock/CardBlock'
import NavBar from '@app/components/Common/NavBar/NavBar'
import PropTypes from '@app/components/PropTypes'

class SelectActionColorTypeAfterDuration extends React.Component {
  onBackClick = () => {
    const {
      navigate,
    } = this.props
    navigate(ADJUST_DURATION_COLOR)
  }

  onChooseClick=(type) => {
    const {
      saveDurationValueAfterActionColorType,
      navigate,
    } = this.props
    saveDurationValueAfterActionColorType(type)
    navigate(SELECT_COLOR_ACTION_HUE_AFTER_DURATION)
  }

  render() {
    const {
      classes,
      isMobile,
    } = this.props
    return (
      <Paper className={classNames(
        classes.wrapper,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
        && classes.webView,
      )}
      >
        <NavBar
          title="create_scene"
          withButton={false}
          isMobile={isMobile}
          backClick={this.onBackClick}
        />
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classes.title}>{I18n.t('scene_action_web.select_colour_type_after_duration')}</Typography>
        </Wrapper>
        <Wrapper className={classes.main}>
          <CardBlock
            key={I18n.t(`scene_web.${setColors.title}`)}
            description={I18n.t(`scene_web.${setColors.description}`)}
            position={setColors.position}
            buttonName={I18n.t(`scene_web.${setColors.buttonName}`)}
            isCardDisabled={setColors.isCardDisabled}
            isButtonDisabled={setColors.isButtonDisabled}
            onClick={() => {
              this.onChooseClick(ColorTypes.swatch)
            }}
          />
          <CardBlock
            key={I18n.t(`scene_web.${rgbColors.description}`)}
            description={I18n.t(`scene_web.${rgbColors.description}`)}
            position={rgbColors.position}
            buttonName={I18n.t(`scene_web.${rgbColors.buttonName}`)}
            isCardDisabled={rgbColors.isCardDisabled}
            isButtonDisabled={rgbColors.isButtonDisabled}
            onClick={() => {
              this.onChooseClick(ColorTypes.rgb)
            }}
          />
          <CardBlock
            key={I18n.t(`scene_web.${whiteWarm.description}`)}
            description={I18n.t(`scene_web.${whiteWarm.description}`)}
            position={whiteWarm.position}
            buttonName={I18n.t(`scene_web.${whiteWarm.buttonName}`)}
            isCardDisabled={whiteWarm.isCardDisabled}
            isButtonDisabled={whiteWarm.isButtonDisabled}
            onClick={
              () => {
                this.onChooseClick(ColorTypes.whiteWarm)
              }
            }
          />
          <CardBlock
            key={I18n.t(`scene_web.${whiteCold.description}`)}
            description={I18n.t(`scene_web.${whiteCold.description}`)}
            position={whiteCold.position}
            buttonName={I18n.t(`scene_web.${whiteCold.buttonName}`)}
            isCardDisabled={whiteCold.isCardDisabled}
            isButtonDisabled={whiteCold.isButtonDisabled}
            onClick={
              () => {
                this.onChooseClick(ColorTypes.whiteCold)
              }
            }
          />
        </Wrapper>
      </Paper>
    )
  }
}

SelectActionColorTypeAfterDuration.propTypes = {
  classes: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  saveDurationValueAfterActionColorType: PropTypes.func.isRequired,
}

SelectActionColorTypeAfterDuration.displayName = 'SelectActionColorTypeAfterDuration'

export default SelectActionColorTypeAfterDuration
